var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 96,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.257 64.13c-3.736 1.953-23.087 9.93-27.207 12.085s-6.41 2.133-9.663.573S54.54 66.887 50.83 65.11C48.975 64.22 48 63.47 48 62.762v-7.095s26.81-5.853 31.14-7.4 5.83-1.613 9.513-.26S114.36 53.335 118 54.672l-.002 6.995c.001.7-.84 1.47-2.74 2.464",
    fill: "#912626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.256 57.078C111.52 59.03 92.17 67.01 88.05 69.162s-6.408 2.133-9.663.573-23.848-9.902-27.557-11.68-3.787-3.002-.143-4.433L79.14 42.577c4.328-1.557 5.83-1.613 9.513-.26s22.92 9.03 26.56 10.367 3.78 2.44.045 4.393",
    fill: "#c6302b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.257 52.65c-3.736 1.953-23.087 9.93-27.207 12.086s-6.41 2.132-9.663.572S54.54 55.407 50.83 53.63C48.975 52.74 48 51.99 48 51.282v-7.096s26.81-5.852 31.14-7.4 5.83-1.614 9.513-.26S114.36 41.853 118 43.19l-.002 6.996c.001.7-.84 1.47-2.74 2.464",
    fill: "#912626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.256 45.597c-3.735 1.952-23.087 9.93-27.206 12.085s-6.408 2.132-9.663.572-23.848-9.902-27.557-11.68-3.787-3.002-.143-4.433L79.14 31.097c4.328-1.557 5.83-1.613 9.513-.26s22.92 9.03 26.56 10.367 3.78 2.44.045 4.393",
    fill: "#c6302b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.257 40.744c-3.736 1.952-23.087 9.93-27.207 12.086s-6.41 2.132-9.663.572S54.54 43.5 50.83 41.723c-1.854-.89-2.83-1.64-2.83-2.347V32.28s26.81-5.852 31.14-7.41 5.83-1.613 9.513-.26S114.36 29.948 118 31.285l-.002 6.995c.001.7-.84 1.47-2.74 2.464",
    fill: "#912626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.256 33.69c-3.735 1.952-23.087 9.93-27.206 12.085s-6.408 2.132-9.663.573S54.54 36.447 50.83 34.67s-3.787-3.002-.144-4.433L79.14 19.192c4.328-1.557 5.83-1.613 9.513-.26s22.92 9.03 26.56 10.368 3.78 2.44.045 4.392",
    fill: "#c6302b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.554 26.79l-6.018.627-1.347 3.25-2.176-3.628-6.95-.626 5.185-1.875-1.556-2.88 4.855 1.904 4.577-1.503-1.237 2.976 4.667 1.752M83.83 42.56L72.597 37.89l16.095-2.477-4.863 7.15M68.257 28.596c4.75 0 8.602 1.497 8.602 3.344s-3.85 3.344-8.602 3.344-8.602-1.497-8.602-3.344 3.85-3.344 8.602-3.344",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#621b1c",
    d: "M98.667 27.678l9.525 3.775-9.517 3.77-.008-7.546"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a2928",
    d: "M88.128 31.858l10.538-4.18.008 7.546-1.033.405-9.513-3.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/Redis.b27c01b9e21fdbd45395ae8bee94b168.svg";
export { ForwardRef as ReactComponent };